import { render } from "./Transaction.vue?vue&type=template&id=1a0493ff"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"
script.render = render

export default script